import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';

import { CircleLoading } from '../icon/icon-map';
import { phxWebStyleTokens } from '../../styles/phx-tokens';
import { PhxSpinnerSize, PhxSpinnerBackground } from './phx-spinner.types';
import { PHX_ICON_SIZE, PHX_SIZE, PHX_BACKGROUND } from '../../constants';

@Component({
  selector: 'phx-spinner',
  template: `<i phx-icon [phxIcon]="SpinnerIcon" [color]="color" [size]="size"></i>`,
  styleUrls: ['./phx-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'phx-spinner', '[class.phx-spinner-centered]': 'phxCentered' },
})
export class PhxSpinnerComponent {
  @Input() phxSize: PhxSpinnerSize = PHX_SIZE.XL;
  @Input() phxBackground: PhxSpinnerBackground = PHX_BACKGROUND.STANDARD;
  @Input() phxCentered: boolean = false;
  public readonly SpinnerIcon: string = CircleLoading;

  public get size(): number {
    if (this.phxSize === PHX_SIZE.XS) return PHX_ICON_SIZE.XS;
    if (this.phxSize === PHX_SIZE.SM) return PHX_ICON_SIZE.SM;
    if (this.phxSize === PHX_SIZE.LG) return PHX_ICON_SIZE.LG;
    if (this.phxSize === PHX_SIZE.XL) return PHX_ICON_SIZE.XL;
    if (this.phxSize === PHX_SIZE.XXL) return PHX_ICON_SIZE.XXL;
    return PHX_ICON_SIZE.MD;
  }

  public get color(): string {
    if (this.phxBackground === PHX_BACKGROUND.MEDIUM) return phxWebStyleTokens.colorContentOnMedium;
    if (this.phxBackground === PHX_BACKGROUND.BOLD) return phxWebStyleTokens.colorContentOnBold;
    if (this.phxBackground === PHX_BACKGROUND.SUMMARY) return phxWebStyleTokens.colorContentOnSummary;
    if (this.phxBackground === PHX_BACKGROUND.INVERTED) return phxWebStyleTokens.colorContentOnInverted;
    if (this.phxBackground === PHX_BACKGROUND.DARK) return phxWebStyleTokens.colorContentOnAlwaysDark;
    if (this.phxBackground === PHX_BACKGROUND.OVERLAY) return phxWebStyleTokens.colorContentOnOverlay;
    return phxWebStyleTokens.colorContentEmphasis;
  }
}
